import React from 'react';
import ErrorMessage from '../../../../ErrorMessage';
import TpJobService from '../../../../../Services/TpJobService';
import LoadingIcon from '../../../../LoadingIcon';
import MultiChoice from './MultiChoice';

export default class TpJobThirdPartyStatusMultiSelect extends React.Component
{
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => { },
    selected: [],
  };

  constructor (props)
  {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount ()
  {
    this.populateListData();
  }

  componentDidUpdate (prevProps)
  {
    if (prevProps.selected !== this.props.selected)
    {
      this.populateListData();
    }
  }

  populateListData ()
  {
    TpJobService.GetThirdPartyJobStatusList()
      .then((result) =>
      {
        const optValues = [];
        const selected = [];
        result.forEach((status) =>
        {
          const newValue = { label: status, value: status };
          optValues.push(newValue);
          if (this.props.selected && this.props.selected.includes(status))
          {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected,
        });
      })
      .catch(() =>
      {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TPJSMS53');
      });
  }

  multiSelectOnChange (selected)
  {
    this.setState({ selected });
    this.props.onChange(selected);
  }

  renderList ()
  {
    const sel = this.state.selected.map((s) => s.value);
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={sel}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render ()
  {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={`htmlidfor${this.props.fieldName}`}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderList()
          )}
        </div>
      </div>
    );
  }
}
